'use strict';

function AuthAcceptController($http, $location, $timeout) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.tokenValidate = tokenValidate;
  vm.tokenDenied = tokenDenied;
  vm.tokenAccepted = tokenAccepted;

  function $onInit() {
    vm.validated = false;
    vm.token = $location.search()['token'];
    vm.invite = vm.invite === true;
    vm.denied = false;

    $timeout(vm.tokenValidate, 2000);
  }

  function tokenValidate() {
    return $http.post('/validate_token/', { token: vm.token, method: vm.invite ? 'acceptinvite' : 'set_password' })
      .then(vm.tokenAccepted)
      .catch(vm.tokenDenied);
  }

  function tokenAccepted() {
    vm.validated = true;
  }

  function tokenDenied() {
    vm.denied = true;

    $timeout(function() {
      $location.search('');
      return $location.path('login');
    }, 0);
  }
}

module.exports = AuthAcceptController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/auth/auth-accept/auth-accept.controller.js
 ** module id = 178
 ** module chunks = 0
 **/